// extracted by mini-css-extract-plugin
module.exports = {"container":"_1alse","arrow":"_2I4xH","page":"_39sv_","position":"_1-gNv","withPosition":"uW36c","active":"_1sfnh","disabled":"_1aPCi"};